import { useEffect, useState } from 'react';
import { App } from '../App';

export type PrerenderPayload = {
  kind: 'work' | 'series' | 'person' | 'curation';
  title: string;
  description: string;
  canonicalPath: string;
  eyebrow: string;
  artworkUrl?: string | null;
  contributor?: string | null;
  series?: string | null;
  excerpt?: string | null;
  itemCount?: number | null;
};

export function PrerenderDocument({ payload }: { payload: PrerenderPayload }) {
  return <main className="prerender-document"><nav><a href="/"><img src="/brand/library-lockup.svg" alt="Eternally Blessed Library" /></a><a href="/search">Search</a><a href="/saved">Saved</a></nav><article>{payload.artworkUrl ? <img className="prerender-document__art" src={payload.artworkUrl} alt="" /> : null}<div className="section-kicker">{payload.eyebrow}</div><h1>{payload.title}</h1>{payload.contributor || payload.series ? <p className="prerender-document__meta">{[payload.contributor, payload.series].filter(Boolean).join(' · ')}</p> : null}<p className="prerender-document__description">{payload.description}</p>{payload.excerpt ? <section><h2>From this work</h2><p>{payload.excerpt}</p></section> : null}{payload.itemCount ? <p>{payload.itemCount} ordered library works</p> : null}<a className="primary-action" href={payload.canonicalPath}>Open the interactive library</a></article></main>;
}

export function HydratingPrerender({ payload }: { payload: PrerenderPayload }) {
  const [enhanced, setEnhanced] = useState(false);
  useEffect(() => setEnhanced(true), []);
  return enhanced ? <App /> : <PrerenderDocument payload={payload} />;
}
